import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { Helmet } from "react-helmet";

export class Rent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      services: [],
      resources: []
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name,
    }));
    if (isAuthenticated) {
      this.populateCompaniesData();
    }
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (data.length > 0) {
      const response1 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/services`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data1 = await response.json();
      this.setState(prevState => ({...prevState, services: data1}));

      const response2 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/resources`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data2 = await response.json();
      this.setState(prevState => ({...prevState, resources: data2.filter(d => d.assigned)}));
    }
  }

  render () {
    return (
      <div class="main">
        <Helmet>
          <title>Система учёта и бронирования аренды | Прокат оборудования — Planna</title>
          <meta name="description" content="Управляйте арендой инструментов, техники или одежды. Клиенты видят фото и выбирают конкретные единицы. Контроль возврата, история, напоминания. Бесплатно." />
        </Helmet>
        <h1 class="main2">Управляйте парком оборудования как в большом прокате — с фото и историей каждой единицы</h1>
        <h2 class="main2">Клиенты выбирают конкретную модель, а не абстрактную услугу</h2>
        <div class="main3">Как это работает:</div>
        <div class="main3">Вы загружаете фото каждой единицы техники или оборудования или загружаете схему со всем доступным оборудованием</div>
        <div class="w40">
          Для каждого экземпляра указываете:
          <ul class="main3">
            <li>Характеристики и технические параметры</li>
            <li>Состояние (новое/б/у, последнее ТО)</li>
            <li>Комплектация и навесное оборудование</li>
            <li>Цену за смену/день/неделю</li>
            <li>Доступность в конкретные даты</li>
          </ul>
        </div>
        <div class="w40 main3">
        Что видит сотрудник:
        </div>

        <div class="w40 main3">
        Календарь показывает, какие единицы техники свободны, какие в аренде, а какие на обслуживании. Можно забронировать конкретный экскаватор или сразу посмотреть все доступные модели
        </div>

        <div class="w40 main3">
        Что видит клиент при онлайн-бронировании:
        </div>

        <div class="w40">
          <ul class="main3">
            <li>Листает карусель фотографий техники</li>
            <li>Видит точные характеристики и состояние</li>
            <li>Выбирает конкретную единицу (например, "вот этот вибропогружатель с пробегом 200 моточасов")</li>
            <li>Может добавить дополнительное навесное оборудование одним кликом</li>
            <li>Получает полную смету без скрытых платежей</li>
          </ul>
        </div>

        <div class="w40 main3">
        Для аренды одежды:
        </div>

        <div class="w40">
          <ul class="main3">
            <li>Клиент выбирает конкретный размер и цвет</li>
            <li>Видит фото именно этого экземпляра (а не "картинку из каталога")</li>
            <li>Может посмотреть, на каких датах вещь уже забронирована</li>
            <li>Видит календарь доступности с подсветкой свободных дней</li>
          </ul>
        </div>

        <div class="w40 main3">
        Преимущества:
        </div>
        <div class="main3 w40"><table style={{textAlign: "left"}} class="table table-striped">
          <thead><tr><th>Для владельца</th><th>Для арендатора</th></tr></thead>
          <tbody>
            <tr>
            <td>Полный контроль над каждой единицей</td><td>Выбор конкретного экземпляра (не "кот в мешке")</td>
            </tr><tr>
            <td>История обслуживания и ремонтов</td><td>Прозрачные характеристики и состояние</td>
            </tr><tr>
            <td>Автоматические напоминания о возврате</td><td>Возможность забронировать с запасом</td>
            </tr><tr>
            <td>Аналитика загрузки и доходности</td><td>Добавление допоборудования в один клик</td>
            </tr><tr>
            <td>Фотофиксация состояния при выдаче/приёме</td><td>Общение с владельцем через чат</td>
            </tr>
          </tbody></table>

        </div>

        <h2 class="main2">Как это работает за 5 минут</h2>
        <p class="main3">
          <div class="nowrap">{this.state.isAuthenticated ? <><span class="btndone">Зарегистрироваться</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="authentication/register">Зарегистрироваться</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Зарегистрировать бизнес бесплатно</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configcompany">Зарегистрировать бизнес бесплатно</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить услуги</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configservices">Добавить услуги</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить русурсы</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configresources">Добавить русурсы (объекты аренды)</a>}<div class="arrowright"></div></div>
          <div class="nowrap"><a style={{marginLeft: "5px"}} class="btn btn-primary" href="configqrcode">Распечатать QR-код со ссылкой для клиентов</a><div class="arrowright"></div></div>
          <a style={{marginLeft: "5px"}} class="btn btn-primary" href={this.state.companies.length > 0 ? `booking/${this.state.companies[0].id}` : "booking"}>Начать записывать клиентов</a>
        </p>
      </div>
    );
  }
}
